<style scoped>
    /*div .row{
        margin-top:10px;
        height:auto
    }*/
</style>
<template>
    <div v-if="controller">
        <!--
        <div class="row" v-if="controller.IsUpdating">
            <div class="col-md-12">
                <div class="panel panel-warning">
                    <div class="panel-body text-warning">
                        <strong><i class="fa fa-info-circle"></i>&nbsp; Changing Dosage mid-cycle will stop the current Item and create a new Item with updated dosage.</strong>
                        <p>Select the appropriate start date from when the new dosage will be active.</p>
                        <p class="text-danger" v-if="controller.hasError"><i class="fa fa-exclamation-triangle "></i> Please Clear errors below</p>
                    </div>
                </div>
            </div>
        </div>
            -->
        <!--<div class="row" v-if="!controller.IsUpdating">
            <div class="col-md-6">
                <div v-if="controller.IsNew">
                    <div class="form-group" v-bind:class="{ 'has-error' : controller.drug.hasError,'has-warning' : controller.drug.hasWarning ,'has-success' : controller.drug.hasSuccess}" style="height:100%">
                        <label class="control-label" for="focusedInput">{{controller.drug.name}}</label>
                        <DrugSearchSelector v-model="controller.drug.value" style="height:auto"></DrugSearchSelector>{{controller.drug.value}}
                        <span class="help-block" v-if="controller.drug.hasWarning || controller.drug.hasError" style="margin-top:10px">
                            <i class="fa" v-bind:class="{ 'fa-exclamation-circle' : controller.drug.hasError,'fa-exclamation-triangle' : controller.drug.hasWarning }"></i>
                            <small>{{controller.drug.message}}</small>
                        </span>
                    </div>
                </div>
                <div>
                    <div class="form-group" style="height:100%">
                        <label class="control-label">Drug</label>
                        <input class="form-control" v-model="controller.drug.value.searchText" disabled />
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <forminput v-bind:controller="controller.quantity"></forminput>
            </div>
            <div class="col-md-3">
                <forminput v-bind:controller="controller.unitOfMeasure"></forminput>
            </div>
        </div>-->
        <!--
        <div class="row">

            <div class="col-md-3" v-if="!controller.IsNew">
                <datepicker :controller="controller.newDosageStartDate" :start-date="today" :end-date="controller.endDate.value"></datepicker>
            </div>
            <div class="col-md-3" v-if="!controller.IsNew">
                <label>End Date</label>
                <input class="form-control" readonly :value="FormatDate(controller.endDate.value)" />
            </div>
            <div class="col-md-6">
                <forminput v-bind:controller="controller.dosageInstruction"></forminput>
            </div>
        </div>
        -->
        <div class="row">
            <div class="col-md-6">
                <forminput v-bind:controller="controller.dosageInstruction"></forminput>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <div class="form-group" style="height:100%">
                    <label class="control-label" v-bind:class="{ 'text-danger' : controller.roundsController.hasError,'text-warning' : controller.roundsController.hasWarning ,'text-success' : controller.roundsController.hasSuccess}">Rounds {{controller.roundsController.message}}</label>
                    <RoundSelector :controller="controller.roundsController"></RoundSelector>
                </div>
            </div>
            <div class="col-md-6">
                <label class="control-label" v-bind:class="{ 'text-danger' : controller.daysOfDosage.hasError,'text-warning' : controller.daysOfDosage.hasWarning ,'text-success' : controller.daysOfDosage.hasSuccess}">Dosage {{controller.daysOfDosage.message}}</label>
                <ScheduleSelector :controller="controller.daysOfDosage" :Start-date="controller.startDate.value"></ScheduleSelector>
            </div>

        </div>
        <div class="row">

            <!--<div class="col-md-6"  v-if="!controller.IsUpdating">
                <forminput v-bind:controller="controller.notes"></forminput>
            </div>-->
        </div>
        <div class="row" v-if="!controller.IsUpdating">
            <!--<br />
            <div class="col-md-2">
                <formcheckbox :controller="controller.isInsulin"></formcheckbox>
            </div>
            <div class="col-md-2">
                <formcheckbox :controller="controller.showInEMAR "></formcheckbox>
            </div>
            <div class="col-md-2">
                <formcheckbox :controller="controller.treatAsCD"></formcheckbox>
            </div>
            <div class="col-md-2">
                <formcheckbox :controller="controller.useBodyMap"></formcheckbox>
            </div>-->
        </div>
    </div>
</template>
<script>

    import DrugSearchSelector from "../DrugSearchSelector/DrugSearchSelector.scp.html"
    import forminput from "../../corecontrols/forminput/forminput.scp.html"
    import formcheckbox from "../../corecontrols/formcheckbox/formcheckbox.scp.html"
    import datepicker from "../../corecontrols/datepicker/datepicker.scp.html"
    import ScheduleSelector from "../ScheduleSelector/ScheduleSelector.scp.html";
    import RoundSelector from "../RoundSelector/RoundSelector.scp.html";
    //import { WardCycleDto, PatientOrderItemDto, DispensationItemDto, MedRoundDto } from './../../../dto/Dtos';
    //import Formatter from "../../corecontrols/formatters/Formatter";
    //import { OrderItemController, OrderItemControllerHelper, OrderGroupController } from './OrderItemController'
    //import DrugStatusSelector from "./../drugStatusSelector/drugStatusSelector.scp.html";
    //import DrugQuantityEditor from "./../drugQuantityEditor/drugQuantityEditor.scp.html";
    //import Dal from './../../../scripts/dataaccess';
    //import TooltipControl from './../../corecontrols/tooltipcontrol/tooltipcontrol.scp.html';
    //import LoaderControl from './../../corecontrols/loaderControl/loaderControl.scp.html';
    //import WorkerButton from './../../corecontrols/workerbutton/workerbutton.scp.html';
    import moment from 'moment'
    import DispensationItemController from './DispensationItemController'
    import Formatter from "../../corecontrols/formatters/Formatter";


    export default {
        props: ['controller'],
        data: function () {
            return {
                today: moment(new Date()).subtract(1, 'days').toDate()
            }
        },
        methods: {
            FormatDate: (d) => Formatter.FormatDate(d)
        },
        components: {
            DrugSearchSelector,
            forminput,
            ScheduleSelector,
            RoundSelector,
            datepicker,
            formcheckbox,
            //WorkerButton
        }
    }

    //export default {
    //    props: ['mode','patient', 'cycle', 'dispensationItem', 'ward'],
    //    data: function () {
    //        return {
    //            controller: undefined
    //        }
    //    },
    //    watch: {
    //        ward() {
    //            if (this.ward && this.ward.wardRounds) {
    //                var dispensationItem = this.dispensationItem ? this.dispensationItem : null;
    //                this.controller = new MedProfileEditorController(this.cycle, this.patient, this.ward, dispensationItem);
    //            }
    //        }
    //    },
    //    mounted() {
    //        var dispensationItem = this.dispensationItem ? this.dispensationItem : null;
    //        if (this.ward && this.ward.wardRounds) {
    //            this.controller = new MedProfileEditorController(this.cycle, this.patient, this.ward, dispensationItem);
    //        }
    //    },
    //    components: {
    //        DrugSearchSelector,
    //        forminput,
    //        ScheduleSelector,
    //        RoundSelector,
    //        datepicker,
    //        formcheckbox
    //    }
    //}
</script>



// WEBPACK FOOTER //
// DispensationItemEditor.scp.html?e0b1bc6e